module.exports = __webpack_public_path__ + "static/img/saoma.59c58d50.png";